import { getJsData } from './js-data';

export const trans = () => getJsData().translations;
